import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;

  justify-content: space-between;
  align-items: center;

  height: 58px;

  background: ${colors.green};

  margin: 20px 30px 0px;

  border-radius: 4px;
  background: ${colors.green};
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
  border-radius: 4px;

  & > div:first-child {
    padding-left: 10px;
    flex: 2;
    justify-content: flex-start;
  }
  & > div {
    flex: 1;
  }
`

export const ContainerItem = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;
`

export const Label = styled.span`
  font-size: 14px;
  color: ${colors.white};
`

export const Value = styled.span`
  font-size: 14px;
  font-weight: 900;
  color: ${colors.white};
`
